import React from 'react'

import Base from '../_Base'

const Brazil16 = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <g clipPath="url(#brazil_16)">
      <rect width="24" height="24" rx="2" fill="#EC1D25" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.849 13.318c0-.516-.034-.85-.102-1.009a.373.373 0 0 0-.369-.232c-.175 0-.3.09-.374.266-.068.176-.108.499-.108.975v1.395c0 .516.034.85.102 1.009.069.153.193.232.375.232.175 0 .295-.085.368-.255.068-.17.108-.499.108-.986v-1.395Zm2.04-4.042v.108h-2.034v-.108c0-.516-.034-.85-.103-1.009a.373.373 0 0 0-.368-.232c-.176 0-.3.09-.374.266-.068.176-.108.505-.108.975v2.035c.176-.232.38-.408.601-.521.221-.114.482-.17.771-.17.561 0 .975.181 1.236.538.26.357.391.936.391 1.724v1.082c0 1.225-.187 2.07-.555 2.534-.369.465-1.02.698-1.956.698-.941 0-1.593-.233-1.962-.692-.368-.465-.555-1.31-.555-2.54v-3.94c0-1.224.187-2.069.555-2.528.369-.46 1.02-.692 1.962-.692.946 0 1.598.176 1.956.528.362.351.544.997.544 1.944ZM8.533 6.969h1.707v10.056H8.295V9.548a3.2 3.2 0 0 1-.55.454 3.421 3.421 0 0 1-.646.317V8.516c.346-.198.64-.425.884-.686.238-.26.425-.544.55-.861Z"
        fill="#fff"
      />
    </g>
    <rect x=".5" y=".5" width="23" height="23" rx="1.5" stroke="#fff" />
    <defs>
      <clipPath id="brazil_16">
        <rect width="24" height="24" rx="2" fill="#fff" />
      </clipPath>
    </defs>
  </Base>
)

export default Brazil16
